import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-64bcad14")

_pushScopeId("data-v-64bcad14")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
_popScopeId()

import { ref, onMounted, reactive, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import wx from 'wx';
import {getmyself} from "@/api/index"
import { waitingSuggestList } from '@/api/MemberHealthQuestion'
import { watch } from 'vue';
import { getMemberBaseInfo } from '@/api/member'



export default _defineComponent({
  expose: [],
  setup(__props) {

    
const data = reactive({
    pageNo: 0,
    dataList: [],
})


const loading = ref(false);
const finished = ref(false);

const onLoad = () => {
    loading.value = true;
    waitingSuggestList(data.pageNo).then(respData => {
        console.log("respData", respData);

        respData.content.forEach(v => {

            // status 
            v['_isSubmitted'] = v.status === 10
            v['_isCompleted'] = v.status === 20

            v['_badgeContent'] = v._isSubmitted ? '已提交' : v._isCompleted ? '已完成': '-'
            v['_badgeColor'] = v._isSubmitted ? '#ee0a24' : v._isCompleted ? 'green': '-'
        })

        Array.prototype.push.apply(data.dataList, respData.content);
        data.pageNo++;

        if(data.pageNo === respData.totalPage){
            finished.value = true;
        }
        loading.value = false;

    })
};


onMounted(async ()=>{

    onLoad();

})

function toExpertSuggest(id){
    wx.miniProgram.navigateTo({
    url: '/pages/healthQuestionnaire/expertSuggest/expertSuggest?id=' + id,
    })
}


return /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_col = _resolveComponent("van-col")
  const _component_van_row = _resolveComponent("van-row")
  const _component_van_cell = _resolveComponent("van-cell")
  const _component_van_list = _resolveComponent("van-list")
  const _component_van_empty = _resolveComponent("van-empty")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (data.dataList.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_van_list, {
            loading: loading.value,
            "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => (loading.value = $event)),
            finished: finished.value,
            "finished-text": "没有更多了",
            onLoad: onLoad
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(data.dataList, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_cell, {
                  key: index,
                  onClick: ($event: any) => (toExpertSuggest(item.id))
                }, {
                  title: _withId(() => [
                    _createVNode(_component_van_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_van_col, {
                          span: "4",
                          style: {"line-height":"0"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_van_icon, {
                              name: "records",
                              size: "30"
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_van_col, {
                          span: "10",
                          style: {"display":"flex","align-items":"center"}
                        }, {
                          default: _withId(() => [
                            _createVNode("div", null, _toDisplayString(item.remarkName || item.userName), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_van_col, {
                          span: "10",
                          style: {"display":"flex","align-items":"center"}
                        }, {
                          default: _withId(() => [
                            _createVNode("div", null, _toDisplayString(item.createTime), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished"])
        ]))
      : (_openBlock(), _createBlock(_component_van_empty, {
          key: 1,
          image: require('@/assets/img/empty-data.png'),
          "image-size": "80",
          description: "无数据"
        }, null, 8, ["image"]))
  ]))
})
}

})